__turbopack_context__.v({
  "className": "sBcmVW_className",
  "variable": "sBcmVW_variable",
});
